import { API } from '@/api/index';
export default {
    name: "Footer",
    created() {
        this.$nextTick(function () {
            this.GetFooter()
        });
    },
    mounted() {
        this.$nextTick(function () {
            $('.selectFooter').on('select2:select', this.handleSelect2Clickf);

            
        })
    },
    data() {
        return {
            Data: [],
            DataNar: [],
            REGION: process.env.VUE_APP_REGION,
        };
    },
    computed: {

    },
    watch: {

    },
    methods: {
        async GetFooter() {
            try {
                const result = await API.get('GetFooter', { lang: localStorage.getItem('Language') || '1' });
                this.Data = result.data;

            } catch (error) {
                this.Data = []
                console.error('API Error:', error);
            } finally {
                for (let i = 0; i < this.Data.Top_Menu.length; i += 4) {
                    this.DataNar.push(this.Data.Top_Menu.slice(i, i + 4));
                }
            }
        },
        handleSelect2Clickf: function (e) {
            if (e.params.data.id != '/') {
                console.log('GTM 23', `'event': 'country_switch'`, `'location_name': ${e.params.data.text.trim()}`, `'action_data': 'footer'`);

                gtag('event', 'country_switch', {
                    'location_name': e.params.data.text.trim(),
                    'action_data': 'footer'
                });
                window.open(e.params.data.id, '_blank');
            }
        }
    },
    components: {

    }
};